'use client';

import { useAuthMutations  } from '@/modules/authentication/contracts';
import type { ForgotPasswordDto } from '@/modules/authentication/contracts';

import { Result } from '@packages/domain-driven';

export const useForgotPassword = () => {
	const { forgotPasswordMutation } = useAuthMutations();

	const submit = async (dto: ForgotPasswordDto) => {
		try {
			await forgotPasswordMutation.mutateAsync(dto);

			return Result.ok();
		}
		catch {
			return Result.fail('Error sending forgot password email');
		}
	};

	return {
		submit,
		...forgotPasswordMutation,
	};
};
